var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnapproveicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.22607 6.22287V17.8715C4.22607 18.6372 4.53026 19.3716 5.07172 19.913C5.61318 20.4545 6.34756 20.7587 7.1133 20.7587H16.7374C16.8246 20.7587 16.9114 20.7547 16.9975 20.747L12.5646 15.7058L11.6434 16.6271C11.4629 16.8075 11.2181 16.9088 10.9629 16.9088C10.7077 16.9088 10.463 16.8075 10.2825 16.6271L8.3577 14.7022C8.18239 14.5207 8.08538 14.2776 8.08758 14.0253C8.08977 13.7729 8.19098 13.5316 8.36942 13.3531C8.54786 13.1747 8.78925 13.0735 9.04159 13.0713C9.29393 13.0691 9.53703 13.1661 9.71854 13.3414L10.9629 14.5858L11.2912 14.2576L4.22607 6.22287ZM15.2314 13.039L15.493 12.7774C15.6683 12.5959 15.7653 12.3528 15.7631 12.1005C15.7609 11.8481 15.6597 11.6067 15.4813 11.4283C15.3028 11.2499 15.0615 11.1487 14.8091 11.1465C14.5568 11.1443 14.3137 11.2413 14.1322 11.4166L13.958 11.5908L5.09785 1.51477C5.12785 1.51194 5.1581 1.5105 5.18848 1.5105H13.8502C14.1054 1.51055 14.3501 1.61198 14.5306 1.79248L19.3426 6.60453C19.5231 6.78498 19.6246 7.02973 19.6246 7.28496V17.8715C19.6246 17.9245 19.6232 17.9774 19.6203 18.0302L15.2314 13.039ZM17.3014 7.28496L13.8502 3.83375V7.28496H17.3014Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.81177,
    y: 1,
    width: 26.0293,
    height: 2.41255,
    rx: 1.20627,
    transform: "rotate(48.674 3.81177 1)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnapproveicon);
export default __webpack_public_path__ + "static/media/unapprove.icon.1d19e3c15b27187a85bac5450f5b1d04.svg";
export { ForwardRef as ReactComponent };